const PropTypes = require('prop-types');
const React = require('react');
const { CategoryNestedNav, NewsNav, SafeLink, UserStore } = require('@reverbdotcom/discovery-ui');
const HelpDropdown = require('./help_dropdown');

const NavLinks = (props) => (
  <ul className="site-header__nav__links">
    <li className="site-header__show-on-mobile" data-dropdown-trigger>
      <span
        className="site-header__nav__link site-header__nav__link--categories"
        onClick={() => { /* noop handler for mobile safari */ }}
        data-dropdown-close-trigger
      >
        {I18n.t('js.navLinks.browseByCategory')}
      </span>
      <div className="site-header__menu site-header__menu--categories" data-dropdown>
        <CategoryNestedNav />
      </div>
    </li>
    <li data-dropdown-trigger>
      <a href="/news" className="site-header__nav__link site-header__nav__link--articles">
        {I18n.t('js.navLinks.newsFull')}
      </a>
      <NewsNav />
    </li>

    <li>
      <a href="/price-guide" className="site-header__nav__link">
        {I18n.t('js.navLinks.priceGuide')}
      </a>
    </li>

    <li>
      <a href="/page/reverb-gives" className="site-header__nav__link">
        {I18n.t('js.navLinks.reverbGives')}
      </a>
    </li>

    <li>
      <a href="/page/artist" className="site-header__nav__link">
        {I18n.t('js.navLinks.artists')}
      </a>
    </li>

    <li>
      <a href="/shops" className="site-header__nav__link">
        {I18n.t('js.navLinks.shops')}
      </a>
    </li>

    {(UserStore.getState().shippingRegionCode === 'US_CON' || UserStore.getState().shippingRegionCode === 'XX') &&
      <li>
        <a href="https://lp.reverb.com" className="site-header__nav__link site-header__nav__link--lp">
          {I18n.t('js.lp')}
        </a>
      </li>
    }

    <li data-dropdown-trigger>
      <span
        className="site-header__nav__link site-header__nav__link--help"
        onClick=""
        data-dropdown-close-trigger
      >
        {I18n.t('js.navLinks.needHelp')}
      </span>
      <div className="site-header__menu site-header__menu--help" data-dropdown>
        <HelpDropdown
          submitHelpRequestUrl={props.submitHelpRequestUrl}
          helpUrl={props.helpUrl}
          dashboardBuyingOrdersPath={props.dashboardBuyingOrdersPath}
          reverbProtectionUrl={props.reverbProtectionUrl}
          isUSDepartment={props.isUSDepartment}
        />
      </div>

    </li>

    <li className="site-header__show-only-on-mobile">
      <a
        href="/sell"
        className="site-header__nav__link site-header__nav__link--sell-link"
        data-selling
        data-source="nav_header"
      >
        {I18n.t('js.navLinks.sellFull')}
      </a>
    </li>
  </ul>
);

NavLinks.propTypes = {
  submitHelpRequestUrl: PropTypes.string,
  helpUrl: PropTypes.string,
  dashboardBuyingOrdersPath: PropTypes.string,
  reverbProtectionUrl: PropTypes.string,
  isUSDepartment: PropTypes.bool,
};

module.exports = NavLinks;



// WEBPACK FOOTER //
// ./javascripts/components/header/nav_links.jsx